var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (based_on) {
buf.push("<div class=\"abrv-follow-annotation\">Based on <a" + (jade.attr("href", based_on.href, true, true)) + ">" + (jade.escape((jade_interp = based_on.name) == null ? '' : jade_interp)) + "</a></div>");}.call(this,"based_on" in locals_for_with?locals_for_with.based_on:typeof based_on!=="undefined"?based_on:undefined));;return buf.join("");
};
module.exports = template;